/**
 * 数据类型检测
 */

/**
 * 是否数组
 * @param taret
 */
export function isArray(target: any): target is any[] {
  return Array.isArray(target);
}

/**
 * 是否布尔
 * @param target
 */
export function isBoolean(target: any): target is boolean {
  return Object.prototype.toString.call(target) === '[object Boolean]';
}

/**
 * 是否日期
 * @param target
 */
export function isDate(target: any): target is Date {
  return Object.prototype.toString.call(target) === '[object Date]';
}

/**
 * 是否函数
 * @param target
 */
export function isFunction(target: any): target is (...args: any[]) => any {
  return Object.prototype.toString.call(target) === '[object Function]';
}

/**
 * 是否null
 * @param target
 */
export function isNull(target: any): target is null {
  return target === null;
}

/**
 * 是否undefined
 * @param target
 */
export function isUndefined(target: any): target is undefined {
  return target === undefined;
}

/**
 * 是否数值
 * @param target
 */
export function isNumber(target: any): target is number {
  return !(
    isNull(target)
    || isUndefined(target)
    || isNaN(target)
    || typeof target !== 'number'
  );
}

/**
 * 是否对象
 * @param target
 */
export function isObject(target: any): target is object {
  const type = typeof target;
  return (target && (type === 'object' || type === 'function')) || false;
}

/**
 * 是否为普通键值对 对象
 * @param target
 */
export function isPlainObject(target: any) {
  return isObject(target) && Object.getPrototypeOf(target) === Object.prototype;
}

/**
 * 是否正则
 * @param target
 */
export function isRegExp(target: any): target is RegExp {
  return Object.prototype.toString.call(target) === '[object RegExp]';
}

/**
 * 是否字符串
 * @param target
 */
export function isString(target: any): target is string {
  return Object.prototype.toString.call(target) === '[object String]';
}

/**
 * 判断数据与对象是否为空
 */
export function isEmpty(target: any): boolean {
  if (isArray(target)) {
    return target.length === 0;
  }

  if (isObject(target)) {
    return Object.keys(target).length === 0;
  }

  return true;
}

export default {
  isArray,
  isBoolean,
  isDate,
  isFunction,
  isNull,
  isUndefined,
  isNumber,
  isObject,
  isPlainObject,
  isRegExp,
  isString,
  isEmpty,
};
